import { render, staticRenderFns } from "./edite-bsk-lglist.vue?vue&type=template&id=45430ad2&scoped=true"
import script from "./edite-bsk-lglist.vue?vue&type=script&lang=js"
export * from "./edite-bsk-lglist.vue?vue&type=script&lang=js"
import style0 from "./edite-bsk-lglist.vue?vue&type=style&index=0&id=45430ad2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45430ad2",
  null
  
)

export default component.exports